module.exports = __webpack_public_path__ + "static/media/13_l_holst_0_55.74.4bab4c12.png";